<template>
  <Popover placement="bottom" :width="410" :customColor="'#ffffff'">
    <slot v-if="mode === 'highlighter'">
      <div @click=";" class="icon-button line-size no-select">
        <span v-if="colorSelected === 0" class="eraser-preview-HL">
          <i class="fal fa-eraser"></i>
        </span>
        <div
          v-else
          class="circle-base-preview"
          :class="annotationUtils.getHLPenColors()[colorSelected].baseClass"
        ></div>
      </div>
    </slot>
    <slot v-else>
      <div
        @click=";"
        class="icon-button line-size no-select"
        :style="{'border-bottom': lineThicknessSelected + 'px solid ' + annotationUtils.hlIndexToColor(colorSelected)}"
      >
        <span v-if="colorSelected === 0" class="eraser-preview-PM">
          <i class="fal fa-eraser"></i>
        </span>
        <span
          v-else
          :style="{'color' : annotationUtils.hlIndexToColor(colorSelected)}"
        >{{lineThicknessSelected}}pt</span>
      </div>
    </slot>
    <div slot="content">
      <div class="no-select">
        <div
          v-for="(color, i) in annotationUtils.getHLPenColors()"
          v-bind:key="i"
          v-on:click="changeColor(i)"
          :style="colorSelected === i ? 'border-bottom: 2px solid ' + annotationUtils.hlIndexToColor(i) : ''"
          :class="i === 0 ? 'eraser' : 'color'"
        >
          <i v-if="i === 0" class="fal fa-eraser"></i>
          <div v-else :class="'circle-base ' + color.baseClass"></div>
        </div>
      </div>
      <div v-if="mode === 'pen'" class="line-picker no-select">
        <div
          v-for="i in [1,2,3,4]"
          v-bind:key="i"
          v-on:click="changeLineSize(i)"
          :style="lineThicknessSelected === i ? 'color:black; border-bottom: ' + i + 'px solid black' : ''"
          :class="'line line-'+i"
        >{{i}}pt</div>
      </div>
    </div>
  </Popover>
</template>

<script>
import Popover from "@/components/widgets/popover";
import annotationUtils from "@/utils/annotationUtils.js";

export default {
  name: "HLPenStylePicker",
  components: {
    Popover
  },
  props: {
    mode: {
      type: String,
      required: true
    },
    settings: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      annotationUtils: annotationUtils,
      colorSelected: 1,
      lineThicknessSelected: 1
    };
  },
  mounted() {
    this.colorSelected =
      this.mode === "highlighter"
        ? this.settings.hlColor
        : this.settings.penColor;
    this.lineThicknessSelected = this.settings.lineThickness;
  },
  methods: {
    changeColor: function(color) {
      this.colorSelected = color;
      this.$emit("colorChange", {
        colorIndex: this.colorSelected,
        mode: this.mode
      });
    },
    changeLineSize: function(line) {
      this.lineThicknessSelected = line;
      this.$emit("lineChange", line);
    }
  }
};
</script>

<style lang="scss">
.line-size {
  font-size: 15px;
  width: 22px;
}

.eraser {
  font-size: 40px;
  margin-left: 10px;
  vertical-align: top;
  float: left;
  padding-top: 5px;
  cursor: pointer;
  i {
    vertical-align: top;
  }
}

.eraser-preview-PM {
  font-size: 20px;
  margin-right: 22px;
}

.eraser-preview-HL {
  font-size: 22px;
  margin-right: 20px;
  margin-top: -5px;
  margin-bottom: -1px;
  display: block;
}

.color {
  padding-top: 5px;
  display: inline-block;
  padding-bottom: 10px;
  margin-left: 10px;
  cursor: pointer;
  width: 40px;
  border-bottom: 2px solid white;
}

.circle-base {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.circle-base-preview {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.purple {
  background: rgb(241, 0, 249);
}

.red {
  background: rgb(255, 0, 0);
}

.yellow {
  background: rgb(170, 255, 0);
}

.green {
  background: rgb(0, 242, 122);
}

.blue {
  background: rgb(0, 173, 255);
}

.black {
  background: rgb(24, 24, 24);
}

.line-picker {
  margin-top: 10px;
  margin-left: 8px;
  padding-top: 10px;
  border-top: 1px solid #e4e4e4;

  .line {
    display: inline-block;
    width: 40px;
    font-size: 20px;
    margin-right: 12px;
    padding-bottom: 10px;
    padding-left: 5px;
    color: #adadad;
    cursor: pointer;
  }

  .line-1 {
    border-bottom: 1px solid #adadad;
    color: #adadad;
  }
  .line-2 {
    border-bottom: 2px solid #adadad;
    color: #adadad;
  }
  .line-3 {
    border-bottom: 3px solid #adadad;
    color: #adadad;
  }
  .line-4 {
    border-bottom: 4px solid #adadad;
    color: #adadad;
  }
}
</style>